import { Box, Boxed, Grid, Spinner, Stack, Text4 } from "@telefonica/mistica";
import React from "react";

interface IProps {
	title: string;
}

export const LoadingContainer: React.FC<IProps> = (props) => {
	const { title } = props;

	return (
		<Box paddingX={24}>
			<Stack space={32}>
				<Grid columns={{ maxSize: 200 }} justifyContent="center" gap={80}>
					<Grid columns={{ maxSize: 104 }} justifyContent="center">
						<Boxed className="boxed-component-shadow ">
							<Box paddingX={24} paddingY={24}>
								<Spinner size={56} />
							</Box>
						</Boxed>
					</Grid>
				</Grid>
				<Grid columns={{ maxSize: 327 }}>
					<Box className="text-align-center">
						<Text4 regular>{title}</Text4>
					</Box>
				</Grid>
			</Stack>
		</Box>
	);
};
